// Rendering helpers for the Business 360 panel — badge colors + formatting. The data
// dictionary (spec §4) defines the vocabularies; B360 resolves them server-side, the panel
// only colors them.

const GREEN = '#1f7a44';
const RED = '#b3261e';
const AMBER = '#9a6700';
const MUTED = '#6b7770';

// license_status: active | suspended | expired | inactive | unverified (spec §4). suspended /
// unverified are retained (never hidden) — badged but not build_ready.
export function license_color(status: string | null): string {
  switch (status) {
    case 'active':
      return GREEN;
    case 'suspended':
      return RED;
    case 'unverified':
      return AMBER;
    case 'expired':
    case 'inactive':
      return MUTED;
    default:
      return MUTED;
  }
}

// confidence_overall: high | medium | low (per-record, spec §4).
export function confidence_color(c: string | null): string {
  switch (c) {
    case 'high':
      return GREEN;
    case 'medium':
      return AMBER;
    case 'low':
      return RED;
    default:
      return MUTED;
  }
}

export function fmt_dt(iso: string | null): string {
  // Defensive: only format strings — never let an unexpected object reach a React child.
  if (typeof iso !== 'string' || !iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}

export function fmt_usd(n: number | null | undefined): string {
  return typeof n === 'number' ? `$${n.toFixed(2)}` : '—';
}

export function painter_name(p: { legal_name: string | null; dba_name: string | null; business_id: string }): string {
  return p.legal_name ?? p.dba_name ?? p.business_id;
}

// Only http(s) links are safe to render as anchors (a verified_claim source_url should always
// be one, but never trust an upstream string into an href).
export function safe_http_url(url: string | null | undefined): string | null {
  if (typeof url !== 'string') return null;
  try {
    const u = new URL(url);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.toString() : null;
  } catch {
    return null;
  }
}
